import React from "react";
import { FormattedMessage } from "react-intl";

import { makeStyles } from "@material-ui/core/styles";

import questionStyle from "assets/jss/material-kit-pro-react/Pages/landingPageSections/questionStyle.js";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import Question1 from "assets/img/logos/Question1.svg";
import Question2 from "assets/img/logos/Question2.svg";
import Question3 from "assets/img/logos/Question3.svg";
import Question4 from "assets/img/logos/Question4.svg";

// import TagManager from "react-gtm-module";

const style = {
  ...questionStyle,
  justifyContentCenter: {
    justifyContent: "center",
  },
};

const useStyles = makeStyles(style);

export default function SectionQuestions() {
  const classes = useStyles();

  // TagManager.dataLayer({
  //   dataLayer: {
  //     path: "/#section_questions",
  //     page: "section_questions",
  //   },
  //   dataLayerName: "PageView",
  // });

  return (
    <div id="section_questions" className={classes.section}>
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="top-bottom"
        className={classes.sectionText}
      >
        <h1 className={classes.title}>
          <span style={{ fontWeight: 700 }}>
            <FormattedMessage
              id="land.questions.title"
              defaultMessage="Perguntas Frequentes"
            />
          </span>
        </h1>
        <br />
        <h1 className={classes.subTitle}>
          <span style={{ fontWeight: 100 }}>
            <FormattedMessage
              id="land.questions.subtitle1"
              defaultMessage="Dúvidas sobre "
            />
          </span>
          <span style={{ fontWeight: 700 }}>
            <FormattedMessage
              id="land.questions.subtitle2"
              defaultMessage="EyeFlow Inspection"
            />
          </span>
        </h1>
        <div style={{ marginTop: "5vh" }} className={classes.sectionCards}>
          <Card profile plain>
            <CardHeader className={classes.cardTitle}>
              <img className={classes.cardIcon} src={Question1} alt="" />
              <FormattedMessage
                id="land.questions.cardTitle1"
                defaultMessage="Quais tipos de defeitos podem ser detectados?"
              />
            </CardHeader>
            <CardBody>
              <h1
                className={classes.cardDescription}
                style={{ fontWeight: 400 }}
              >
                <FormattedMessage
                  id="land.questions.cardBody1"
                  defaultMessage="O EyeFlow Inspection detecta qualquer defeito visual: riscos, amassados, trincas, bolhas, falta de componentes, deformações, manchas, etiquetas incorretas e muito mais. O sistema aprende com exemplos reais da sua linha — se um humano consegue ver, o EyeFlow detecta."
                />
              </h1>
            </CardBody>
          </Card>
          <Card profile plain>
            <CardHeader className={classes.cardTitle}>
              <img className={classes.cardIcon} src={Question2} alt="" />
              <FormattedMessage
                id="land.questions.cardTitle2"
                defaultMessage="Quanto tempo leva para implementar?"
              />
            </CardHeader>
            <CardBody>
              <h1
                className={classes.cardDescription}
                style={{ fontWeight: 400 }}
              >
                <FormattedMessage
                  id="land.questions.cardBody2"
                  defaultMessage="A implementação inicial leva tipicamente de 2 a 8 semanas, dependendo da complexidade do processo. Isso inclui configuração, treinamento inicial do modelo e integração com a linha de produção — muito menos do que soluções tradicionais de machine vision."
                />
              </h1>
            </CardBody>
          </Card>
        </div>
        <br />
        <div className={classes.sectionCards}>
          <Card profile plain>
            <CardHeader className={classes.cardTitle}>
              <img className={classes.cardIcon} src={Question3} alt="" />
              <FormattedMessage
                id="land.questions.cardTitle3"
                defaultMessage="É necessário ter especialistas em IA ou programação?"
              />
            </CardHeader>
            <CardBody>
              <h1
                className={classes.cardDescription}
                style={{ fontWeight: 400 }}
              >
                <FormattedMessage
                  id="land.questions.cardBody3"
                  defaultMessage="Não. O EyeFlow Inspection foi projetado para ser operado pelo próprio time de qualidade da indústria. A interface é intuitiva e o treinamento de novos defeitos ou modelos de peças pode ser feito pelo operador, sem nenhum conhecimento técnico em IA."
                />
              </h1>
            </CardBody>
          </Card>
          <Card profile plain>
            <CardHeader className={classes.cardTitle}>
              <img className={classes.cardIcon} src={Question4} alt="" />
              <FormattedMessage
                id="land.questions.cardTitle4"
                defaultMessage="Quais câmeras e equipamentos são necessários?"
              />
            </CardHeader>
            <CardBody>
              <h1
                className={classes.cardDescription}
                style={{ fontWeight: 400 }}
              >
                <FormattedMessage
                  id="land.questions.cardBody4"
                  defaultMessage="O EyeFlow Inspection é compatível com a maioria das câmeras industriais e de segurança já existentes na planta. A execução pode ser feita em um PC industrial ou dispositivo edge na linha. "
                />
                <a href="/contact-us">
                  <FormattedMessage
                    id="land.questions.cardBody4-2"
                    defaultMessage="Fale com nossa equipe "
                  />
                </a>
                <FormattedMessage
                  id="land.questions.cardBody4-3"
                  defaultMessage="para avaliarmos a compatibilidade com a sua infraestrutura atual."
                />
              </h1>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
